import { getJson, postJson } from '../../../utils/api';
import IHandler from './IHandler';

export type DelinquentRunStatus = 'running' | 'done' | 'failed';

export interface DelinquentRun {
  runId: string;
  startedAt: string;
  status: DelinquentRunStatus;
  triggeredBy?: string;
  includeCategoryA: boolean;
  finishedAt?: string;
  fileName?: string;
  errorMessage?: string;
  processed?: number;
  total?: number;
  downloadUrl?: string | null;
}

export interface DelinquentRunsResponse {
  running: boolean;
  runs: DelinquentRun[];
}

export default class TasksHandler implements IHandler {
  static route = '/admin/tasks';
  static resourceIdName = 'userId';

  static async startTask(taskName: string, data: any, onSuccess: () => void, onFailure: (err: string) => void) {
    return postJson(`${this.route}/${taskName}`, data)
      .then(async () => {
        onSuccess();
        return {
          data: {},
        };
      })
      .catch((response) => {
        onFailure(
          `${response.status}:${response.error.message ?? JSON.stringify(response.error, null, 2)}:${response.message}`
        );
        return Promise.reject({
          status: response.status,
          error: response.statusText,
          message: response.statusText,
        });
      });
  }

  static async listDelinquentRuns(): Promise<DelinquentRunsResponse> {
    const response = await getJson(`${this.route}/collections-delinquent`);
    if (!response.ok) {
      throw new Error(`Failed to load delinquent runs (${response.status})`);
    }
    const body = await response.json();
    // SuccessResult wraps the payload under `data`; tolerate an unwrapped body too.
    return (body?.data ?? body) as DelinquentRunsResponse;
  }
}
